import * as Resolvers from "./resolvers";
export default Resolvers;